import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

/** 策展页每张「一工具一卡」的外壳：标题 + `tool · 已启用/总数` + 一句说明。 */
export function ToolCard(props: {
  title: string;
  tool: string;
  blurb: string;
  enabled: number;
  total: number;
  children: ReactNode;
}): JSX.Element {
  const { t } = useTranslation();
  return (
    <section className="space-y-2 rounded border border-dosia-border/60 p-3">
      <div>
        <h2 className="text-sm font-medium text-dosia-text">{props.title}</h2>
        <p className="mt-0.5 text-xs text-dosia-text-secondary">
          {props.tool} · {t("admin.toolCuration.count", { enabled: props.enabled, total: props.total })}
        </p>
        <p className="mt-1 text-xs text-dosia-text-secondary">{props.blurb}</p>
      </div>
      {props.children}
    </section>
  );
}
